import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useTranslation } from '@ibk/shared-translation';
import { Breadcrumb, Button, Icon, Loading } from '@ibk/shared-ui';
import { useDownloadPDF } from '../../hooks/useDownloadPDF';
import { useLazyGetSlipPdfQuery } from '../../services/receiptApi/receiptApi';
import styles from './ChargesPDFViewer.module.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
export function ChargesPDFViewer({ slipId, onBack, onDownloadPDF, className, dataTestId = 'charges-pdf-viewer', }) {
    const { t } = useTranslation();
    const [numPages, setNumPages] = useState(0);
    const [getPdfTrigger, { data: pdfData, isLoading, error }] = useLazyGetSlipPdfQuery();
    const { downloadPDF, createPDFBlob } = useDownloadPDF();
    useEffect(() => {
        if (slipId) {
            getPdfTrigger({ slipId });
        }
    }, [slipId, getPdfTrigger]);
    const getPdfFile = () => {
        return createPDFBlob(pdfData?.result?.data || null);
    };
    const handleDownloadPDF = () => {
        const pdfFile = getPdfFile();
        const filename = `boleto-cobranca-${slipId}`;
        downloadPDF(pdfFile, filename);
        if (onDownloadPDF) {
            onDownloadPDF(slipId);
        }
    };
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };
    const onDocumentLoadError = (error) => {
        console.error('PDF load error:', error);
    };
    const breadcrumbItems = [
        {
            label: t('charges-pdf-viewer.breadcrumb.charges'),
            onClick: onBack,
            isActive: false,
        },
        {
            label: t('charges-pdf-viewer.breadcrumb.pdf'),
            isActive: true,
        },
    ];
    if (isLoading) {
        return (_jsx("div", { className: `${styles.container} ${className ?? ''}`, "data-testid": dataTestId, children: _jsx("div", { className: styles.loadingContainer, children: _jsx(Loading, { size: 'medium' }) }) }));
    }
    if (error) {
        return (_jsx("div", { className: `${styles.container} ${className ?? ''}`, "data-testid": dataTestId, children: _jsxs("div", { className: styles.error, children: [_jsx(Icon, { name: 'circleError', className: styles.errorIcon }), _jsx("span", { children: t('charges-pdf-viewer.error') })] }) }));
    }
    return (_jsxs("div", { className: `${styles.container} ${className ?? ''}`, "data-testid": dataTestId, children: [_jsxs("div", { className: styles.header, children: [_jsx(Breadcrumb, { items: breadcrumbItems, className: styles.breadcrumb }), _jsx("div", { className: styles.actions, children: _jsx(Button, { variant: 'primary', size: 'small', leftIcon: 'downloadWhite', onClick: handleDownloadPDF, dataTestId: 'charges-pdf-viewer-download', className: styles.downloadButton, children: t('charges-pdf-viewer.download-slip') }) })] }), _jsx("div", { className: styles.pdfContainer, children: getPdfFile() ? (_jsx(Document, { file: getPdfFile(), onLoadSuccess: onDocumentLoadSuccess, onLoadError: onDocumentLoadError, className: styles.pdfDocument, loading: _jsx("div", { className: styles.loadingContainer, children: _jsx(Loading, { size: 'medium' }) }), error: _jsxs("div", { className: styles.pdfError, children: [_jsx(Icon, { name: 'circleError', className: styles.errorIcon }), _jsx("span", { children: t('charges-pdf-viewer.error') })] }), children: Array.from(new Array(numPages), (el, index) => (_jsx(Page, { pageNumber: index + 1, className: styles.pdfPage, renderTextLayer: false, renderAnnotationLayer: false, scale: 1.2, loading: _jsx("div", { className: styles.loadingContainer, children: _jsx(Loading, { size: 'medium' }) }) }, `page_${index + 1}`))) })) : (_jsxs("div", { className: styles.noPdf, children: [_jsx(Icon, { name: 'document', className: styles.noPdfIcon }), _jsx("span", { children: t('charges-pdf-viewer.no-pdf') })] })) })] }));
}
